import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, mergeClasses, Radio, RadioGroup, Spinner, Text } from '@fluentui/react-components';
import { Dismiss24Regular } from '@fluentui/react-icons';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useCommonStyles } from '../../../common/hooks';

export type ExportType = 'PDF' | 'WORD';
const availableTypes: {
  displayName: string;
  typeCode: ExportType;
}[] = [
    {
      displayName: 'PDF',
      typeCode: 'PDF'
    },
    {
      displayName: 'Word',
      typeCode: 'WORD'
    }
  ];

interface ExportNominationsModalProps {
  isModalOpen: boolean;
  isDownloading: boolean;
  onCancelButtonClicked(): void;
  onExportButtonClicked(exportedType: ExportType): void;
}

const ExportNominationsModalImpl: React.FC<ExportNominationsModalProps> = (props) => {
  const {
    isModalOpen,
    isDownloading,
    onCancelButtonClicked,
    onExportButtonClicked,
  } = props;

  const commonStyles = useCommonStyles();

  const [selectedExportedType, setSelectedExportedType] = useState<ExportType>('PDF');

  return (
    <Dialog
      open={isModalOpen}
      onOpenChange={(_, data) => {
        if (!data.open && !isDownloading) onCancelButtonClicked();
      }}
    >
      <DialogSurface 
        className={mergeClasses(commonStyles.modalSurface, 'export-nominations-modal')}
      >
        <DialogBody 
          className={commonStyles.modalBody}
        >
          <DialogTitle
            action={
              <Button
                appearance='subtle'
                aria-label='close'
                icon={<Dismiss24Regular />}
                onClick={() => onCancelButtonClicked()} 
              />
            }
          >
            Export nominations
          </DialogTitle>
          <DialogContent>
            <Text>Select how you would like the nominations exported?</Text>
            <RadioGroup
              value={selectedExportedType}
              onChange={(_, data) => setSelectedExportedType(data.value as ExportType)}
            >
              {availableTypes.map((availableType) => (
                <Radio
                  key={availableType.typeCode}
                  value={availableType.typeCode}
                  label={availableType.displayName}
                />
              ))}
            </RadioGroup>
          </DialogContent>
          <DialogActions>
            <Button 
              appearance='secondary' 
              onClick={() => onCancelButtonClicked()}
            >
              Cancel
            </Button>
            <Button 
              appearance='primary' 
              disabled={isDownloading}
              onClick={() => onExportButtonClicked(selectedExportedType)}
              icon={isDownloading ? <Spinner size='tiny' /> : undefined}
            >
              Export
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export const ExportNominationsModal = observer(ExportNominationsModalImpl);
